<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';
const SHARED_CONTENT_LAYOUT_TO_CLASSES = {
  'navbar-secondary': () => {
    const auxNav = $("#navbar-auxiliary");
    if (!auxNav) {
      return 'sticky-header';
    } else {
      return 'sticky-auxiliary-navbar';
    }
  }
}

export default {
  mixins: [fandomBasicMixin],
  mounted() {
    const c = JSON.parse(JSON.stringify(this.content));
    if (c.theme) {
      let content = this.getContent(this.content.content);
      if (content && !Fandom.exists(content.theme)) {
        Vue.set(this.pageModel.name_to_content[content.name], "theme", c.theme);
      }
    }
  },
  computed: {
    classes() {
      let classes = [this.contentType];
      if (this.content.content) {
        const content = this.getContent(this.content.content);
        const getLayoutClasses = SHARED_CONTENT_LAYOUT_TO_CLASSES[content.layout];
        if (!!getLayoutClasses) {
          classes.push(getLayoutClasses());
        }
      }
      return classes;
    }
  }
}
</script>

<template>
  <div v-easyadmin="easyadminId" :class="classes" v-if="isContentVisibleToUser()" shared-content-component>
    <component v-if="content.content && getContent(content.content)" :is="getContent(content.content).layout" :content="getContent(content.content)" :key="getContent(content.content).name">
      <template v-for="(_, name) in $scopedSlots" #[name]="slotData"><slot :name="name" v-bind="slotData"></slot></template>
    </component>
  </div>
</template>

<style lang="scss">
  .sticky-header,
  .sticky-auxiliary-navbar {
    position: sticky;
    z-index: 1010;
    
  }
  .sticky-header {
    top: $header-height;
  }
  .sticky-auxiliary-navbar {
    top: $auxiliary-navbar-height;
  }
</style>
